// Interpret scanner keys by physical position, never by the active alphabet.
export function listenKeyboardScanner({onCode,onEditing}) {
 let buffer='',last=0,lastScan=0,timer,snapshot=null;
 const reset=()=>{buffer='';last=0;snapshot=null;clearTimeout(timer)};
 const editable=el=>!!el?.closest?.('input,textarea,select,[contenteditable="true"],[role="textbox"]');
 const focus=()=>{reset();onEditing(editable(document.activeElement))};
 const key=e=>{
  if(document.hidden||!document.hasFocus()){reset();return}
  if(e.key==='Escape'&&editable(e.target)){e.target.blur();reset();return}
  if(e.isComposing||e.ctrlKey||e.metaKey||e.altKey||e.repeat){reset();return}
  const now=performance.now(),editing=editable(e.target),dialog=!!document.querySelector('[role="dialog"],[aria-modal="true"]');
  if(now-last>100)reset();
  if(e.key==='Enter'||e.code==='NumpadEnter'){
   const code=buffer,prior=snapshot,internal=/^TI[0-9]{20}$/.test(code);reset();
   const scan=internal||(!editing&&!dialog&&code.length>=6);
   if(scan||now-lastScan<300){
    e.preventDefault();e.stopImmediatePropagation();
    if(scan){lastScan=now;
     if(editing||dialog){
      // A scanner burst in a manual field must not submit the form or corrupt it.
      if(internal&&prior&&prior.el===e.target&&'value' in prior.el){
       const proto=prior.el.tagName==='TEXTAREA'?HTMLTextAreaElement.prototype:HTMLInputElement.prototype;
       const setter=Object.getOwnPropertyDescriptor(proto,'value')?.set;
       if(setter){setter.call(prior.el,prior.value);prior.el.dispatchEvent(new Event('input',{bubbles:true}))}
      }
     }else onCode(code);
    }
   }
   return;
  }
  const char=/^Key[A-Z]$/.test(e.code)?e.code.slice(3):/^Digit[0-9]$/.test(e.code)?e.code.slice(5):/^Numpad[0-9]$/.test(e.code)?e.code.slice(6):e.key;
  if(char.length!==1||!/[A-Za-z0-9_-]/.test(char)){reset();return}
  if(!buffer&&editing&&['INPUT','TEXTAREA'].includes(e.target.tagName))snapshot={el:e.target,value:e.target.value};
  if(!editing){e.preventDefault();e.stopImmediatePropagation()}
  buffer+=char;last=now;clearTimeout(timer);
  if(buffer.length>128){reset();return}
  timer=setTimeout(reset,150);
 };
 window.addEventListener('keydown',key,true);
 document.addEventListener('focusin',focus);document.addEventListener('focusout',focus);
 window.addEventListener('blur',reset);document.addEventListener('visibilitychange',reset);focus();
 return ()=>{reset();window.removeEventListener('keydown',key,true);document.removeEventListener('focusin',focus);document.removeEventListener('focusout',focus);window.removeEventListener('blur',reset);document.removeEventListener('visibilitychange',reset)};
}
